<template>
  <div>
    <div v-if="card != null" id="show-card">
      <v-row>
        <v-col cols="12" md="6">
          <v-card>
            <v-card-title
              >Détails de la carte
              <v-spacer></v-spacer>
              <v-btn color="primary" @click.stop="editCardDialog = true" icon>
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <edit-card-dialog
                :open.sync="editCardDialog"
                v-if="editCardDialog"
                :card-original="card"
              ></edit-card-dialog>
            </v-card-title>
            <v-card-text>
              <v-alert v-if="card.lastSessionAt == null" type="warning">
                Carte pas encore utilisée
              </v-alert>
              <v-simple-table dense>
                <template v-slot:default>
                  <tbody>
                    <tr>
                      <td class="font-weight-bold">Login :</td>
                      <td>{{ card.id }}</td>
                    </tr>
                    <tr>
                      <td class="font-weight-bold">Mot de passe :</td>
                      <td>{{ card.password }}</td>
                    </tr>
                    <tr>
                      <td class="font-weight-bold">
                        Etat dernière authentification :
                      </td>
                      <td>{{ card.lastAuthState }}</td>
                    </tr>
                    <tr v-if="card.client != null">
                      <td class="font-weight-bold">Client :</td>
                      <td>
                        <router-link
                          :to="{
                            name: 'portail-details',
                            params: { id: card.client.id },
                          }"
                          >{{ card.client.passmanId }} -
                          {{ card.client.description }}
                        </router-link>
                      </td>
                    </tr>
                    <tr v-if="card.cardOrigin != null">
                      <td class="font-weight-bold">Origine :</td>
                      <td>{{ card.cardOrigin.description }}</td>
                    </tr>
                    <tr v-if="card.cardType != null">
                      <td class="font-weight-bold">Type :</td>
                      <td>{{ card.cardType.description }}</td>
                    </tr>
                    <tr v-if="card.mode != null">
                      <td class="font-weight-bold">Mode :</td>
                      <td>{{ card.mode.description }}</td>
                    </tr>
                    <tr v-if="card.restrictionType != null">
                      <td class="font-weight-bold">Restriction :</td>
                      <td>{{ card.restrictionType.description }}</td>
                    </tr>
                    <tr>
                      <td class="font-weight-bold">
                        Sessions simultanées autorisées :
                      </td>
                      <td>{{ card.simultaneousSessionsNum }}</td>
                    </tr>
                    <tr>
                      <td class="font-weight-bold">
                        Durée total de la connexion :
                      </td>
                      <td>
                        {{
                          card.totalConnectionDuration != null
                            ? `${
                                card.totalConnectionDuration
                              } s (${secondsToHigherUnit(
                                card.totalConnectionDuration
                              )})`
                            : "-"
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td class="font-weight-bold">
                        Durée maximale de connexion :
                      </td>
                      <td>
                        {{
                          card.maxUsageDuration != null
                            ? `${
                                card.maxUsageDuration
                              } s (${secondsToHigherUnit(
                                card.maxUsageDuration
                              )})`
                            : "-"
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td class="font-weight-bold">Idle-timeout :</td>
                      <td>
                        {{
                          card.idleTimeout != null
                            ? `${card.idleTimeout} s (${secondsToHigherUnit(
                                card.idleTimeout
                              )})`
                            : "-"
                        }}
                      </td>
                    </tr>
                    <tr v-if="card.peremptionDate != null">
                      <td class="font-weight-bold">Date de péremption :</td>
                      <td>{{ getInternationalDate(card.peremptionDate) }}</td>
                    </tr>
                    <tr>
                      <td class="font-weight-bold">First used at :</td>
                      <td>{{ getInternationalDate(card.firstUsedAt) }}</td>
                    </tr>
                    <tr>
                      <td class="font-weight-bold">Last session at :</td>
                      <td>{{ getInternationalDate(card.lastSessionAt) }}</td>
                    </tr>
                    <tr>
                      <td class="font-weight-bold">Créée le :</td>
                      <td>{{ getInternationalDate(card.createdAt) }}</td>
                    </tr>
                    <tr>
                      <td class="font-weight-bold">Créée par :</td>
                      <td>{{ card.createdBy }}</td>
                    </tr>
                    <tr>
                      <td class="font-weight-bold">Mis à jour le :</td>
                      <td>{{ getInternationalDate(card.updatedAt) }}</td>
                    </tr>
                    <tr>
                      <td class="font-weight-bold">Mis à jour par :</td>
                      <td>{{ card.updatedBy }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="6">
          <v-card v-if="card.profile != null">
            <v-card-title>Profile </v-card-title>
            <v-card-text>
              <v-simple-table dense>
                <template v-slot:default>
                  <tbody>
                    <tr>
                      <td class="font-weight-bold">Nom :</td>
                      <td>{{ card.profile.lastname }}</td>
                    </tr>
                    <tr>
                      <td class="font-weight-bold">Prénom :</td>
                      <td>{{ card.profile.firstname }}</td>
                    </tr>
                    <tr>
                      <td class="font-weight-bold">Email :</td>
                      <td>{{ card.profile.email }}</td>
                    </tr>
                    <tr>
                      <td class="font-weight-bold">Téléphone :</td>
                      <td>
                        {{ card.profile.phone }}
                      </td>
                    </tr>
                    <tr>
                      <td class="font-weight-bold">Inscrit le :</td>
                      <td>
                        {{
                          getInternationalDate(card.profile.registeredAt.date)
                        }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12">
          <v-card>
            <v-card-title>Adresse MAC associées</v-card-title>
            <v-card-text>
              <authentification-m-a-c-datatable
                :filter-params="filterParams"
              ></authentification-m-a-c-datatable>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12">
          <v-card>
            <v-card-title> Sessions actives </v-card-title>
            <v-card-text>
              <active-session-datatable
                :active-sessions="activesessions"
                :is-portal-client="false"
                :is-card="true"
                :id="cardId"
              ></active-session-datatable>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12">
          <card-attribute-radius
            v-if="card.client != null"
            :cardId="card.id"
          ></card-attribute-radius>
        </v-col>
        <v-col cols="12">
          <v-expansion-panels v-model="accordionLogradius">
            <v-expansion-panel>
              <v-expansion-panel-header class="text-h6">
                Logs Radius
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <logradius-datatable
                  :options="options"
                  @update:options="options = $event"
                  :firstLoad="firstLoad"
                  :is-loading="isLoading"
                  :logsradius="logsradius"
                ></logradius-datatable>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </div>
    <div v-else>
      <LoadingDialog />
    </div>
  </div>
</template>
<script>
import { onMounted, toRefs, ref, watch } from "@vue/composition-api";
import router from "../router";
import { useCard } from "@/composables/card";
import ActiveSessionDatatable from "@/components/ActiveSession/ActiveSessionDatatable";
import { useActiveSession } from "@/composables/activesession";
import CardAttributeRadius from "@/components/Card/CardAttributeRadius";
import { useTitle } from "@/composables/title";
import { date } from "@/composables/date";
import LoadingDialog from "@/components/General/LoadingDialog.vue";
import { useLogRadius } from "@/composables/logradius";
import LogradiusDatatable from "@/components/Logradius/LogradiusDatatable";
import AuthentificationMACDatatable from "../components/AuthentificationMAC/AuthentificationMACDatatable";
import { useTimeUtils } from "../composables/time";
import EditCardDialog from "../components/Card/EditCardDialog";

export default {
  components: {
    EditCardDialog,
    AuthentificationMACDatatable,
    CardAttributeRadius,
    ActiveSessionDatatable,
    LoadingDialog,
    LogradiusDatatable,
  },
  setup() {
    /* Import des API */
    const { setTitle, setIcon } = useTitle();
    const { cardData, showCard } = useCard();
    const cardId = router.currentRoute.params.id;
    const { activesessions, listCardActiveSessions } = useActiveSession();
    const { getInternationalDate } = date();
    const { listLogradiusForCard, logsradius, logradiusData } = useLogRadius();
    const { secondsToHigherUnit } = useTimeUtils();

    /* Variables */
    const accordionLogradius = ref(-1);

    const filterParams = {
      card: cardId,
    };

    /* Watchers */
    watch(
      () => accordionLogradius.value,
      (newValue) => {
        if (newValue == 0) {
          listLogradiusForCard(cardId);
        }
      }
    );
    watch(
      () => cardData.editCardDialog,
      async (newValue) => {
        if (newValue == false) {
          showCard(cardId);
        }
      }
    );

    /* Cycle de vie */
    onMounted(async () => {
      await showCard(cardId);
      setTitle("Carte - " + cardId);
      setIcon("carte");

      listCardActiveSessions(cardId);
    });

    watch(
      () => logradiusData.options,
      async (newValues, oldValues) => {
        if (oldValues.page !== undefined) {
          listLogradiusForCard(cardId);
        }
      },
      {
        deep: true,
      }
    );

    const updateCard = () => {
      console.log("in");
      /*      console.log(event);
      cardData.card = event;*/
    };
    return {
      ...toRefs(cardData),
      activesessions,
      getInternationalDate,
      cardId,
      accordionLogradius,
      logsradius,
      ...toRefs(logradiusData),
      filterParams,
      secondsToHigherUnit,
      updateCard,
    };
  },
};
</script>
